import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MainContainer } from "../MainContainer";
import Loader from "../../components/Loader";
import PaginationComponent from "../../components/PaginationComponent";
import RenderModalContent from "../Users/RenderModalContent";
import RenderUsers from "../Users/RenderUsers";

import {
    getPartners,
    setPartnersPage,
    setPartnersPageSize,
    // сеттеры для slice:
    // setPartnersSort, setPartnersSearch — оставляем, но напрямую их тут не дергаем
    getPartnersWithSort,
    searchPartners,
} from "../../actions/partners.actions";

const PartnerPage = () => {
    const dispatch = useDispatch();

    // партнёрский слайс
    const {
        items, loading, page, pageSize, totalAll, totalPages,
    } = useSelector((s) => s.partnerUser);

    // user slice для модалки деталей
    const { userDetails } = useSelector((s) => s.user);

    // модалка деталей партнёра (переиспользуем Users/RenderModalContent)
    const [userDetailModal, setUserDetailModal] = useState(false);
    const [typeModal, setTypeModal] = useState("details");
    const [currentId, setCurrentId] = useState(null);

    const topRef = useRef(null);

    // первичная загрузка и рефетч на смену пагинации/фильтров (стор обновляет getPartners сам)
    useEffect(() => {
        dispatch(getPartners());
    }, [dispatch, page, pageSize]); // сорт/поиск меняем через thunks, которые сами вызовут getPartners

    const openUserModal = (userId, t = "details") => {
        setCurrentId(userId);
        setTypeModal(t);
        setUserDetailModal(true);
    };
    const closeUserModal = () => {
        setUserDetailModal(false);
        setCurrentId(null);
        setTypeModal("");
    };

    return (
        <MainContainer
            title="Наши партнёры"
            noneCreateButton
            noneSelectUpdatedPictures
            // ——— ЕДИНЫЙ интерфейс, как у Users:
            typeSort="partners"                 // отдельный тип, чтобы не показывать сорт по роли
            search={searchPartners}             // thunk: кладёт search и делает fetch
            get={getPartnersWithSort}           // thunk: принимает sort, кладёт его и делает fetch

            // Пагинация через MainContainer/Sort/Pagination:
            // ВАЖНО: сюда даём ФУНКЦИИ, которые внутри сами сделают dispatch —
            // так Sort сможет вызвать их даже без dispatch внутри себя.
            setPageNumber={(p) => dispatch(setPartnersPage(p))}
            setPageSize={(s) => dispatch(setPartnersPageSize(Number(s)))}
            pageNumber={page}
            pageSize={pageSize}
        >
            <div ref={topRef} />

            {loading ? (
                <Loader />
            ) : (
                <>
                    <RenderUsers
                        variant="partners"            // таблица/карточки под партнёров
                        users={items}
                        showUserDetailsModal={openUserModal}
                        pageNumber={page}
                        pageSize={pageSize}
                    />

                    <PaginationComponent
                        dispatchAction
                        totalPages={totalPages}
                        totalAll={totalAll}
                        pageSize={pageSize}
                        pageNumber={page}
                        setPageNumber={setPartnersPage}   // тут можно прямо action creator — Pagination сам диспатчит
                    />
                </>
            )}

            <RenderModalContent
                typeModal={typeModal}
                currentId={currentId}
                userDetails={userDetails}
                setTypeModal={setTypeModal}
                userDetailModal={userDetailModal}
                handleCloseUserDetailsModal={closeUserModal}
            />
        </MainContainer>
    );
};

export default PartnerPage;
